import numeral from 'numeral';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

export function fCurrency(number: InputValue) {
  const format = number ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function nullSafeMeterToKmDisplayValueWithoutRounding(value: number | null) {
  let meter = ' --- ';
  if (value !== undefined && value !== null) {
    const kilometers = (value / 1000).toString();
    const decimalIndex = kilometers.indexOf('.');
    meter =
      decimalIndex !== -1
        ? kilometers.slice(0, decimalIndex + 3).replace('.', ',') // keep two decimal places without rounding
        : `${kilometers},00`; // ensure two decimal places for whole numbers
  }
  return meter;
}

export function nullSafeEuroDisplayValue(value: number | null) {
  let euro = ' --- ';
  if (value !== undefined && value !== null) {
    euro = `${value.toFixed(2).replace('.', ',')} €`;
  }
  return euro;
}

export function nullAndUndefinedSafeCentToEuro(value: number | null | undefined) {
  if (value) {
    return value / 100;
  }
  return 0;
}

export function transformStringsCommaSeparatedToFloatPointSeparated(
  newValue: number,
  originalValue: number | any
) {
  if (originalValue && originalValue !== '') {
    const transformedValue = originalValue.toString().replace(/,/g, '.') || '0';
    return parseFloat(transformedValue);
  }
  return newValue;
}
